var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-icon"},[(_vm.showCircle)?_c('span',{staticClass:"status-icon__circle",class:("status-icon__circle--" + _vm.status)}):_c('LoadingSmallSpinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }